import email from '../assets/images/email.png';
import mobile from '../assets/images/mobile.png';
import cpp from '../assets/images/cpp.png';
import css from '../assets/images/css.png';
import mobdev from '../assets/images/mobdev.png';
import web from '../assets/images/web.png';
import git from '../assets/images/git.png';
import graphql from '../assets/images/graphql.png';
import html from '../assets/images/html.png';
import javascript from '../assets/images/javascript.png';
import mu5 from '../assets/images/mu5.png';
import node from '../assets/images/node.png';
import python from '../assets/images/python.png';
import react from '../assets/images/react.png';
import redux from '../assets/images/redux.png';
import sass from '../assets/images/sass.png';
import typescript from '../assets/images/typescript.png';
import vue from '../assets/images/vue.png';
import cybersec from '../assets/images/cybersec.png'

import about01 from '../assets/images/about01.png';
import about02 from '../assets/images/about02.png';

import profile from '../assets/images/profile.gif';
import circle from '../assets/svgs/circle.svg';

import service01 from '../assets/images/service01.png'
import service02 from '../assets/images/service02.png'

export default {
  email,
  mobile,
  cpp,
  css,
  mobdev,
  web,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  profile,
  circle,
  cybersec,
  service01,
  service02,
};